// One catalog for the section chooser, mobile drawer, route and Tools tabs.
// Visibility is a usability rule only. The API independently checks authority.
export const TOOLS_VIEWS = Object.freeze([
  Object.freeze({
    id: "quality",
    slug: "data-quality",
    label: "Data Quality",
    permission: "data_quality.view",
    path: "/tools/data-quality",
  }),
  Object.freeze({
    id: "permissions",
    slug: "site-permissions",
    label: "Site Permissions",
    permission: "permissions.manage",
    path: "/tools/site-permissions",
  }),
  Object.freeze({
    id: "bloomberg",
    slug: "bloomberg-jobs",
    label: "Bloomberg Jobs",
    permission: "bloomberg_jobs.use",
    path: "/tools/bloomberg-jobs",
  }),
]);

export function visibleToolsViews(access) {
  return access?.status === "ready" && typeof access.hasPermissions === "function"
    ? TOOLS_VIEWS.filter((view) => access.hasPermissions([view.permission]))
    : [];
}

export function toolsSection(access) {
  const views = visibleToolsViews(access);
  return views.length
    ? {
        group: "tools",
        section: "Tools",
        tabPaths: views.map((view) => view.path),
        sectionEntryPath: views[0].path,
      }
    : null;
}

export function navigationSections(sections, access) {
  const tools = toolsSection(access);
  return tools ? [...sections, tools] : sections;
}

export function sectionForPath(sections, pathname) {
  // Segment boundaries prevent e.g. /tools/data-quality-other from selecting a
  // permitted tool. Existing nested business routes keep their parent section.
  return (
    sections.find((section) => section.tabPaths.some((path) => pathname === path || pathname.startsWith(path + "/"))) ||
    null
  );
}
